import { desktop } from "@storeblocks/global-styles";
import styled from "styled-components";
export const StepList = styled.ol `
  list-style-type: none;
  ${desktop(`
    position: sticky;
    top: 0;
  `)}
  padding: 0;
`;
//# sourceMappingURL=styled.js.map